import { render } from "./TransferFilter.vue?vue&type=template&id=2c4ec881"
import script from "./TransferFilter.vue?vue&type=script&lang=js"
export * from "./TransferFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__